var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle Clock",
    clipPath: "url(#clip0_32_9685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle-clock--clock-loading-measure-time-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 33.75C21.8098 33.75 25.943 32.038 28.9905 28.9905C32.038 25.943 33.75 21.8098 33.75 17.5C33.75 13.1902 32.038 9.05698 28.9905 6.00951C25.943 2.96205 21.8098 1.25 17.5 1.25C13.1902 1.25 9.05698 2.96205 6.00951 6.00951C2.96205 9.05698 1.25 13.1902 1.25 17.5C1.25 21.8098 2.96205 25.943 6.00951 28.9905C9.05698 32.038 13.1902 33.75 17.5 33.75Z",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5 11.25V17.5L23.85 24.9",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_9685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.eec0bac5574ca7660c2e335a1f50ef39.svg";
export { ForwardRef as ReactComponent };